<template>
  <div class="overlay">
    <div class="d-flex justify-content-center spinner">
      <div
        class="spinner-border color"
        role="status"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.color {
  color: var(--theme-color-cta-100);
}

.overlay {
  position: fixed;
  width: 100%;
  top: 0;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.5);
  animation: fadeIn 0.5s ease-in;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
